import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';

@Component({
	selector: 'pcm-ui-action-list',
	templateUrl: './ui-action-list.component.html',
	styleUrls: ['./ui-action-list.component.scss']
})
export class UiActionListComponent implements OnChanges, OnInit {

	@Input() actions = [];
	@Input() actionButton = 'Go';
	@Input() actionsConfig = null;
	@Input() actionListLabel = '';
	@Input() tooltip = '';
	@Input() tooltipPlacement = 'left';
	@Input() selectedAction = null;
	// when null, the first option will be selected. When provided, an option will be created using this text
	@Input() placeholderText = null;
	// when true, this will keep the selected item selected after data change. if the options may change, this should left as false
	@Input() keepSelectionOnChange = false;
	// if true, the action will be taken upon choosing from the list (no action button). if false, the action will be taken when clicking action button
	@Input() takeActionOnSelect = false;

	@Output() actionTaken: EventEmitter<any> = new EventEmitter();

	hasActions = true;

	@Input() allowAction() { return false; }

	constructor(
		private smartContractService: SmartContractService,
	) { }

	ngOnInit() {
		// this needs to happen on load, but also on any changes
		this.configureActions();
	}

	ngOnChanges() {
		this.configureActions();
	}

	configureActions() {
		const self = this;
		if (!this.actions || this.actions.length === 0) {
			// if there is a delay to get actions (ILC reason codes, for example)
			this.hasActions = false;
			this.actions = [{
				name: 'Please make a selection',
				prop: ''
			}];
			this.selectedAction = this.actions[0];
		} else if (this.placeholderText && !this.selectedAction) {
			this.selectedAction = {
				name: this.placeholderText,
				prop: null
			};
		} else {
			let firstAction = -1;
			this.actions.forEach(function(d, i){
				// find first action user has permissions to execute
				if (self.canAction(d) && firstAction === -1) {
					firstAction = i;
				}
			});
			if (firstAction > -1) {
				// set selectionAction to first action except in the case where "keepSelectionOnChange" is set and there is a valid selectedAction
				if (!(this.selectedAction && this.keepSelectionOnChange)) {
					this.selectedAction = this.actions[firstAction];
				}
			} else {
				this.hasActions = false;
			}
		}
	}

	canAction(action) {
		// the following three action doesnt take any input parms
		if (action.prop === 'poarchive'
			|| action.prop === 'porestore'
			|| action.prop === 'exporttocsv') {
			return true;
		}
		let canAction = false;
		if (this.actionsConfig !== null) {
			// if configs are passed in we check for permissions
			// console.log('CAN ACTION', action);
			const actionConfig = this.smartContractService.getSCConfig(this.actionsConfig, action.prop);
			// console.log('ACTION CONFIG', actionConfig);
			if (actionConfig['fields'] !== undefined) {
				actionConfig['fields'].forEach(function (d, i) {
					if (d.edit === true) {
						// if user can edit a field than they can see the action
						canAction = true;
					}
				});
			}
		} else {
			// we allow all actions
			canAction = true;
		}

		return canAction;
	}

	selectAction(action) {
		this.selectedAction = action;

		if (this.takeActionOnSelect) {
			this.takeAction();
		}
	}

	takeAction() {
		console.log('TAKE ACTION', this.selectedAction);
		this.actionTaken.emit({ action: this.selectedAction });
	}

	getSelectedActionTooltip() {
		let tooltip = '';
		if (this.selectedAction && this.selectedAction.tooltip) {
			tooltip = this.selectedAction.tooltip;
		}
		return tooltip;
	}
}
